import PropTypes from 'prop-types';
import React from 'react';

const SearchCategory = ({ handleCategoryChange, selectOptions, selectedCategoryId, chosenCategory }) => {
    if (!selectOptions) {
        return;
    }

    const handleChange = handleCategoryChange;
    const isDefaultSelected = selectedCategoryId === 0;
    let selectKey = 0;

    return (
        <div className={`slim-header__search-category d-flex align-items-center ${!isDefaultSelected ? 'slim-header__search-category--selected' : ''}`}>
            <span className="slim-header__search-category-placeholder arrow-down--after ss-fix--after">
                {chosenCategory.name}
            </span>
            {/*<select name="categoryId" tabIndex="2" className="slim-header__search-category" onChange={onChange} style={{ 'width': `${width <= 12 ? 12 : width}rem` }}>*/}
            <select name="categoryId" tabIndex="2" className="slim-header__search-category-select" onChange={handleChange} value={selectedCategoryId}>
                {
                    selectOptions.map(option => {
                        return option ? <option
                            key={selectKey++}
                            value={option.id}>
                            {option.name}
                        </option> : null
                    })
                }
            </select>
        </div>
    )
}

SearchCategory.propTypes = {
    handleCategoryChange: PropTypes.func,
    selectOptions: PropTypes.array,
    selectedCategoryId: PropTypes.number,
    chosenCategory: PropTypes.object
};

export default SearchCategory;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/search-category/search-category.jsx